<template>
  <div class="footer">
    <div>地址：中国·安徽·淮南</div>
    <div>版权所有：淮南矿业集团员工保障服务中心 未经许可禁止非法拷贝或镜像</div>
    <div>主办：淮南矿业集团员工保障服务中心</div>
    <!-- <div>您是本站的第：{{ index }} 号到访者</div> -->
    <!-- <div>技术支持：山大地纬软件股份有限公司</div> -->
  </div>
</template>
<style lang="scss" scoped>
.footer {
  font-size: 12px;
  width: 100%;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #434343;
  div {
    margin: 5px;
    color: #ffffff;
  }
}
</style>
<script>
export default {
  props: {
    index: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
